<app-logged class="campaign-list">
  <header class="campaign-list__header">
    <h2>Campanhas</h2>
    <div class="campaign-list__header__actions">
      <button class="btn-primary-light" mat-button routerLink="/dashboard/campaign/new">
        ADICIONAR
      </button>
    </div>
  </header>

  <app-form-filter maskExample="000.000.000-00" actions="form" type="campaign" [fieldsForm]="fieldsForm"
    [formGroupValue]="formGroup" (returnFilter)="reciverFeedback($event)"></app-form-filter>

  <div class="table-responsive">
    <table mat-table [dataSource]="campaigns">
      <ng-container matColumnDef="idCampaign">
        <th mat-header-cell *matHeaderCellDef>ID</th>
        <td mat-cell *matCellDef="let element">{{ element.idCampaign }}</td>
      </ng-container>
      <ng-container matColumnDef="campaignTypes">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let element">{{ element.campaignTypes }}</td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Descrição</th>
        <td mat-cell *matCellDef="let element">{{ element.description }}</td>
      </ng-container>

      <ng-container matColumnDef="confirmationCampaignType">
        <th mat-header-cell *matHeaderCellDef>Tipo de confirmação</th>
        <td mat-cell *matCellDef="let element">{{ element.confirmationCampaignType }}</td>
      </ng-container>

      <ng-container matColumnDef="confirmationCampaign">
        <th mat-header-cell *matHeaderCellDef>Confirmação de campanha</th>
        <td mat-cell *matCellDef="let element">{{ element.confirmationCampaign }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button matTooltip="Editar" matTooltipPosition="left"
            routerLink="/dashboard/campaign/{{ element.id }}/edit" [queryParams]="params" skipLocationChange="true">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Remover" (click)="remove(element.id)" matTooltipPosition="left">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="headersTable"></tr>
      <tr mat-row *matRowDef="let row; columns: headersTable"></tr>
    </table>
    <app-form-filter type="campaign" actions="pagination" [length]="pageTotal" [pageSizeOptions]="pageSizeOptions"
      [formGroupValue]="formGroup" (returnFilter)="reciverFeedback($event)">
    </app-form-filter>
  </div>
</app-logged>
